import {
  createIvsDeviceAsync,
  deleteIvsDeviceAsync,
  getAllIvsDeviceCountByLicenseAsync,
  getAllIvsDevicesByLicenseAsync,
  getByIdsAsync,
  getIvsDeviceByIdAsync,
  updateConfigIvsDeviceAsync,
  updateIvsDeviceAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateIvsDeviceAsync = () => useMutation(createIvsDeviceAsync);

export const useGetIvsDeviceByIdAsync = () =>
  useMutation(getIvsDeviceByIdAsync);

export const useUpdateIvsDeviceAsync = () => useMutation(updateIvsDeviceAsync);

export const useDeleteIvsDeviceAsync = () => useMutation(deleteIvsDeviceAsync);

export const useUpdateConfigIvsDeviceAsync = () =>
  useMutation(updateConfigIvsDeviceAsync);

export const useMutationGetAllIvsDevicesByLicenseAsync = () =>
  useMutation(getAllIvsDevicesByLicenseAsync);

export const useMutationGetIvsDevicesByLicenseCountAsync = () =>
  useMutation(getAllIvsDeviceCountByLicenseAsync);

export const useMutationGetIvsDeviceByIdsAsync = () =>
  useMutation(getByIdsAsync);
